export default __webpack_public_path__ + "static/media/HPE-APOLLO-REAR.8d5156b9.png";